import React, { useEffect, useState } from "react";
// import { FcNext, FcPrevious } from "react-icons/fc";
import { useDispatch, useSelector } from "react-redux";
import { campaignAction } from "../../store/campaign-store";
import useHttp from "../../hooks/use-http";
import { endPoints } from "../../config/end-points";





const AiImage = (props) => {

  const { toggleRightshow } = props;
  const dispatch = useDispatch();

  const single_layer = useSelector((state) => state.campaign.single_layer);
  const editSlideData = useSelector((state) => state.campaign.editSlideData);
  const [promt, setPromt] = useState("");
  const {sendRequest: generateImage} = useHttp();
  const [showImageSearchResult, setShowImageSearchResult] = useState(false);
  const [available, setAvailable] = useState(0);
  const [searchImageResults, setSearchImageResults] = useState({});



  

  useEffect(() => {
    if(editSlideData){

        const dataArray = Object.entries(editSlideData);
        let quotes = '';

        dataArray.map(([key, value]) => {
          
          if(key && key.includes("engageleads")){
            quotes += value+' ';
          }

          return null;
        });

        quotes = "Generate Image For the Quote: "+quotes ;
        setPromt(quotes);
        console.log(quotes);

    }
  }, [editSlideData ]);
  

  const promthandle = (data) => {

    console.log(data.target.value);
    setPromt(data.target.value);
  }


  const getImage = async () => {
    
    generateImage(
      {
        url: endPoints.genImage,
        method: "POST",
        body: {
          promt: promt ,
          "size": "1024x1024"
        }
      },
      (response) => {
        // console.log(response);
        setShowImageSearchResult(true);
        setSearchImageResults(response);
        setAvailable(2);
      }
    );
  };


  // console.log("-------------------");
  // console.log(single_layer);
  // console.log(editSlideData);

  const updateNewData = async (e, url) => {
      e.preventDefault();

      if (single_layer.name.indexOf("bg_image") === 0) {
        dispatch(campaignAction.setImageEditor({ content: url }));
      } else {
        console.log('else');
        // let new_layer_data = { ...single_layer };
        // new_layer_data.src = url;

        // await dispatch(
        //   campaignAction.setSingleLayerData({ data: new_layer_data })
        // );

        // await dispatch(
        //   campaignAction.setSingleSlideData({ layer_name: single_layer.name })
        // );

        // dispatch(campaignAction.appendVideoData());

        // var newData = { ...editSlideData };

        // newData.logo = url;
        // dispatch(campaignAction.setSlideData({ data: newData }));

        // dispatch(campaignAction.setImageLoadedS3({ is_loaded_img: false }));
      }
      toggleRightshow();
  };


  return (
    <>
      <div className="row">
          <div className="col-md-12 px-5 text-align-left">
            <div className="mb-3">
              <label className="form-label"><b>Prompt</b></label>
              <textarea type="text" placeholder="Enter Json Data" className="form-control jsondata" onChange={(e) => promthandle(e)}  value={promt} rows='4' >
              </textarea>
            </div>
          </div>

        <div className="d-flex flex-right px-5 pt-2">
          <div className="input-group  justify-content-end">
            
            <button
              className="btn btn-outline-secondary shadow-none p-2"
              type="button"
              id="button-addon2"
              onClick={getImage}
            >
              Generate Image For the Quote
            </button>
          </div>
        </div>
        
      </div>

      <div className="row">
          {showImageSearchResult && (
            <div className="container">
              <div className="media_gallery" style={{ height: "200px" }}>
                {available === 2 && (
                  <ul>
                    {searchImageResults.length > 0 &&
                      searchImageResults.map(
                        ({ url , index}) => (
                          <li key={index}>
                            <img
                              src={url}
                              className="img_full"
                              alt="img"
                            />
                            <button
                              onClick={(e) => updateNewData(e, url)}
                              className="hvr"
                            >
                              <span className="btn">Select</span>
                            </button>
                          </li>
                        )
                      )
                    }
                  </ul>
                )}

                {available === 1 && <p>No data found!</p>}
              </div>
              
            </div>
          )}
        </div>
    </>
  );
};

export default AiImage;
